import { getConfigValue } from "@rumble-it/common-lib/config";
import { ReactNode } from "react";

export const Wrapper = ({
  children,
}: {
  children: ReactNode | ReactNode[];
}) => {
  return (
    <div className="bg-neutral-100 min-h-screen">
      <header className="flex justify-center items-center h-[90px] bg-white border-neutral-300 border-b">
        <img
          width={0}
          height={0}
          alt="RumbleDirect Logo"
          src={`${getConfigValue("cdnUrl")}/static/assets/logos/logo-rumble.svg`}
          className="max-h-[50%] max-w-[50%]"
          style={{ width: "auto", height: "auto" }}
        />
      </header>

      <div className="max-w-screen-xl mx-auto justify-center py-6 pb-5 px-8">
        <main className="grid grid-cols-1 gap-5 text-sm">{children}</main>
      </div>
    </div>
  );
};
